// extracted by mini-css-extract-plugin
export default {"filled":"StarRatring_filled__YeVJw","HalfStar":"StarRatring_HalfStar__GGfYT","starsDiv":"StarRatring_starsDiv__Wpo8m"};